const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

if (!reduceMotion.matches) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8%', threshold: 0.12 });
  document.querySelectorAll('[data-reveal]').forEach((element) => observer.observe(element));

  const world = document.querySelector('[data-triveni-world]');
  const canPoint = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  let frame;

  if (world && canPoint) {
    world.addEventListener('pointermove', (event) => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const rect = world.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        world.querySelectorAll('[data-depth]').forEach((layer) => {
          const depth = Number(layer.dataset.depth || 1);
          layer.style.setProperty('--pointer-x', `${x * depth * 2.2}px`);
          layer.style.setProperty('--pointer-y', `${y * depth * 1.8}px`);
        });
      });
    }, { passive: true });
  }

}

const preloader = document.querySelector('.triveni-preloader');
if (preloader) {
  requestAnimationFrame(() => preloader.classList.add('is-ready'));
  window.addEventListener('pageshow', () => preloader.classList.add('is-ready'), { once: true });
}
